// src/plugins/vuetify.js

import Vue from "vue";
import Vuetify from "vuetify/lib";

Vue.use(Vuetify);

import 'material-design-icons-iconfont/dist/material-design-icons.css'
export default new Vuetify({  icons: {
iconfont: 'md', 

},})